import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './Bars.css';
import { faBars, faGlobe, faChevronDown, faRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import { useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import MenuContext from '../../Context/MenuContext';
import { useLanguage } from '../../Context/LanguageContext';
import { useCurrentUser } from '../../Context/CurrentUserContext';
import { Axios } from '../../API/Axios';
import { LOGOUT } from '../../API/Api';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Cookie from 'cookie-universal';

// بيحدد اسم القسم الحالي من الرابط عشان يتعرض جنب اسم البراند
function getCurrentSectionKey ( pathname )
{
    if ( pathname.includes( 'users/add' ) ) return 'addUser';
    if ( pathname.includes( 'category/add' ) || pathname.includes( 'categories/add' ) ) return 'addCategories';
    if ( pathname.includes( 'products/add' ) ) return 'addProducts';
    if ( pathname.includes( 'categories' ) ) return 'categories';
    if ( pathname.includes( 'products' ) ) return 'products';
    if ( pathname.includes( 'writer' ) ) return 'writer';
    if ( pathname.includes( 'users' ) ) return 'users';
    return null;
}

export default function TopBar ()
{
    const Menue = useContext( MenuContext );
    const setMenuisopen = Menue.setMenuisopen;
    const { lang, toggleLanguage, t } = useLanguage();
    const { user } = useCurrentUser(); // بيانات المستخدم جايه من RequierAuth، من غير طلب تاني
    const cooki = Cookie();
    const navigate = useNavigate();
    const location = useLocation();

    async function handleLogout ()
    {
        try
        {
            await Axios.get( `/${ LOGOUT }` );
            cooki.remove( "ecommerce" );
            navigate( "/auth", { replace: true } );
        }
        catch ( error )
        {
            console.log( error );
        }
    }

    const initial = user?.name ? user.name.charAt( 0 ).toUpperCase() : "?";
    const sectionKey = getCurrentSectionKey( location.pathname );

    return (
        <div className="tob-bar">
            <div className="d-flex align-items-center justify-content-between h-100">
                <div className="tob-bar-brand">
                    <h3 className="mb-0"><span>{ t( 'brand.name' ) }</span></h3>
                    <span className="tob-bar-divider" />
                    <span className="icon-btn" onClick={ () => setMenuisopen( ( prev ) => !prev ) } role="button" aria-label="toggle menu">
                        <FontAwesomeIcon icon={ faBars } />
                    </span>
                    { sectionKey && (
                        <span className="tob-bar-breadcrumb" key={ sectionKey }>
                            { t( `dashboardNav.${ sectionKey }` ) }
                        </span>
                    ) }
                </div>

                <div className="d-flex align-items-center gap-3">
                    <button type="button" className="lang-pill" onClick={ toggleLanguage }>
                        <FontAwesomeIcon icon={ faGlobe } />
                        <span>{ lang === 'ar' ? 'EN' : 'AR' }</span>
                    </button>

                    <DropdownButton
                        id="dropdown-basic-button"
                        variant="link"
                        className="p-0 text-decoration-none"
                        title={
                            <span className="user-chip">
                                <span className="user-chip-avatar-wrap">
                                    <span className="user-chip-avatar">{ initial }</span>
                                    <span className="user-chip-status" aria-hidden="true" />
                                </span>
                                <span className="user-chip-name">{ user?.name }</span>
                                <FontAwesomeIcon icon={ faChevronDown } className="user-chip-caret" />
                            </span>
                        }
                    >
                        <div className="user-menu">
                            <div className="user-menu-header">
                                <span className="user-menu-header-name">{ user?.name }</span>
                                { user?.role && (
                                    <span className="user-menu-header-role">
                                        { t( `roles.${ user.role }` ) }
                                    </span>
                                ) }
                            </div>
                            <div className="user-menu-sep" />
                            <Dropdown.Item className="user-menu-item" onClick={ handleLogout }>
                                <FontAwesomeIcon icon={ faRightFromBracket } />
                                { t( 'nav.logout' ) }
                            </Dropdown.Item>
                        </div>
                    </DropdownButton>
                </div>
            </div>
        </div>
    );
}
